
import DateTimePicker from 'components/GenericComponent/DateTimePicker';
import NumberField from 'components/GenericComponent/NumberField';
import NumberInput from 'components/GenericComponent/NumberInput';
import { PopoversBootrap } from 'components/GenericComponent/PopoversBootrap';
import React, { useState, useRef, useEffect } from "react";
import Modal from 'react-bootstrap/Modal';
import { Controller, useForm } from 'react-hook-form';
import { formatNumber } from 'utils/currencyFormat';
import { convertToNumber } from 'utils/numberExtension';
function ChiTietTongSoTienDaTra(props) {
    let { show, onHide, TT_Amercement,
        TT_OtheFeeHangKy,
        TT_OtherFee,
        TT_PhiHoaHongTraGop,
        TT_PhiKho,
        TT_PhiPhatDongLai,
        TT_ValueGoc,
        TT_ValueLai,
        TT_PhiPhatTatToan } = props;

    return (
        <Modal
            show={show}
            size="modal-dialog modal-dialog"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal-new modal fade text-left"
        >
            <Modal.Header>
                <h4 className="modal-title" id="myModalLabel16">
                    <span class="btn-icon-right">
                        <img src="/app-assets/images/icon-donglai.png" alt="" />
                    </span>
                    Chi tiết tổng số tiền đã trả
                </h4>
                <button type="button" className="close-popup-new" onClick={onHide}>
                    <i className="mdi mdi-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="">
                <div className="from-tinhtrangno">
                    <form className="form tat-toan form-horizontal">
                        <div className="form-body">
                            <div className="col-md-12">
                                <div className='row'>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Tiền gốc:
                                        </label>
                                        <span style={{ color: "#c0392b" }}>{formatNumber(TT_ValueGoc)}</span>
                                    </div>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Tiền lãi:
                                        </label>
                                        <span style={{ color: "#c0392b" }}>{formatNumber(TT_ValueLai)}</span>
                                    </div>
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Phí khác:
                                        </label>
                                        <span style={{ color: "#c0392b" }}>{formatNumber(TT_OtherFee)}</span>
                                    </div>
                                    {TT_PhiKho > 0 && (
                                        <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                            <label style={{ minWidth: "150px" }}>
                                                Phí kho:
                                            </label>
                                            <span style={{ color: "#c0392b" }}>{formatNumber(TT_PhiKho)}</span>
                                        </div>
                                    )}
                                    <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                        <label style={{ minWidth: "150px" }}>
                                            Phí hàng kỳ:
                                        </label>
                                        <span style={{ color: "#c0392b" }}>{formatNumber(TT_OtheFeeHangKy)}</span>
                                    </div>
                                    {(TT_Amercement) > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt:
                                                </label>
                                                <span style={{ color: "#c0392b" }}>{formatNumber(TT_Amercement)}</span>
                                            </div>
                                        </>
                                    )}
                                    {(TT_PhiPhatDongLai) > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt đóng lãi:
                                                </label>
                                                <span style={{ color: "#c0392b" }}>{formatNumber(TT_PhiPhatDongLai)}</span>
                                            </div>
                                        </>
                                    )}
                                    {TT_PhiHoaHongTraGop > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí hoa hồng trả góp:
                                                </label>
                                                <span style={{ color: "#c0392b" }}>{formatNumber(TT_PhiHoaHongTraGop)}</span>
                                            </div>
                                        </>
                                    )}
                                    {TT_PhiPhatTatToan > 0 && (
                                        <>
                                            <div className="col-md-12" style={{ borderBottomWidth: 1, borderBottomColor: "#eeeee7", borderBottomStyle: "solid", paddingTop: 5 }}>
                                                <label style={{ minWidth: "150px" }}>
                                                    Phí phạt tất toán:
                                                </label>
                                                <span style={{ color: "#c0392b" }}>{formatNumber(TT_PhiPhatTatToan)}</span>
                                            </div>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-new-main btn-closenew"
                    onClick={onHide}
                >
                    <span className="btn-icon-left">
                        <i className="mdi mdi-close"></i>
                    </span>
                    Đóng
                </button>
            </Modal.Footer>
        </Modal>
    );
}
export default ChiTietTongSoTienDaTra;
